export const IconCard = ({
  color,
  bgColor,
}: {
  color: string;
  bgColor: string;
}) => {
  return (
    <div
      className={`font-bold text-sm w-[18px] h-[24px] text-center ${color} ${bgColor}`}
    >
      1
    </div>
  );
};
